import { render } from "./ModalHistoricoAtivo.vue?vue&type=template&id=2dfef367&scoped=true"
import script from "./ModalHistoricoAtivo.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoAtivo.vue?vue&type=script&lang=js"

import "./ModalHistoricoAtivo.vue?vue&type=style&index=0&id=2dfef367&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfef367"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QCard,QCardSection,QLinearProgress,QTable,QTr,QTh,QTd,QPagination});
